var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSouthKorea(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v12H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cd2e3a",
    d: "M6.5 6a2.5 2.5 0 0 1 5 0 1.25 1.25 0 0 1-2.5 0 1.25 1.25 0 0 0-2.5 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0047a0",
    d: "M11.5 6a2.5 2.5 0 0 1-5 0A1.25 1.25 0 0 1 9 6a1.25 1.25 0 0 0 2.5 0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#111",
    strokeWidth: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3 2 2 1.4m-2.35-.9 2 1.4m8.35 4.7 2 1.4m-2.35-.9 2 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: ".75 .3",
    d: "m13 3.4 2-1.4m-2.35 2 2-1.4M3 10l2-1.4m-2.35.9 2-1.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthKorea);
export default __webpack_public_path__ + "static/media/south-korea.2ccf62fa7a622dd47976961b7fb08f2a.svg";
export { ForwardRef as ReactComponent };